(function ($) {
    $(function () {

        const likedButton = localize.program_cards_liked_button_url;
        const unLikedButton = localize.program_cards_unliked_button_url;
        const favouriteButton = $('.js-toggle-favourite-program');
        const favouriteProgramsContainer = $('.js-favourite-programs-container');

        // Set saved programs cookies
        if (!Cookies.get('favourite_programs')) {
            var favouritePrograms = [];
        } else {
            var favouritePrograms = JSON.parse(Cookies.get('favourite_programs'));
        }

        // Function to set proper like button on program cards
        function setLikeButton() {
            favouriteButton.each(function (e) {
                var id = $(this).data('id');
                if (favouritePrograms.includes(id)) {
                    $(this).attr('src', likedButton);
                    $(this).parent().addClass('liked');

                } else {
                    $(this).attr('src', unLikedButton);
                    $(this).parent().removeClass('liked');
                }
            })
        }

        $(document).on('click', '.js-toggle-favourite-program', function (e) {
            var id = $(this).data('id');
            if (!favouritePrograms.includes(id)) {
                favouritePrograms.push(id);
            } else {
                favouritePrograms = favouritePrograms.filter(e => e != id);
            }
            Cookies.set('favourite_programs', JSON.stringify(favouritePrograms));

            if ($(this).attr('src') == likedButton) {
                $(this).attr('src', unLikedButton);
                $(this).parent().removeClass('liked');
            } else {
                $(this).attr('src', likedButton);
                $(this).parent().addClass('liked');
            }
        });

        // Get saved programs
        if (favouriteProgramsContainer.length) {
            $('body').addClass('template-wishlist');

            const savedPrograms = JSON.parse(Cookies.get('favourite_programs'));
            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: 'get_favourite_programs',
                    data: savedPrograms
                },
                error: function (error) {
                    console.log(error)
                },
                success: function (response) {
                    favouriteProgramsContainer.append(response);
                }
            });

            $(".js-favourite-programs-container").bind("DOMSubtreeModified", function () {
                $('.js-toggle-favourite-program').attr('src', likedButton);
                $('.js-program-card-text-block').data("matchHeight", "false");
                $('.js-program-card-text-block').matchHeight({ remove: true });
                $('.js-program-card-text-block:visible').matchHeight({
                    byRow: true,
                    property: 'height',
                    target: null,
                    remove: false

                });
            });
        }

        setLikeButton();
    });
})(jQuery);